import { Injectable } from '@angular/core';
import { safeStorage } from '../helpers/safe-storage';
import * as CryptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })
export class CoreArkikCommonService {
  encryptJSONObject(jsonData: any, secretKey: string): string {
    try {
      return CryptoJS.AES.encrypt(JSON.stringify(jsonData), secretKey).toString();
    } catch (e) {
      console.error('Encryption failed', e);
      return null;
    }
  }

  encryptJSONObjectAndSave(jsonData: any, storeKeyName: string, secretKey: string): boolean {
    try {
      const encryptedData = this.encryptJSONObject(jsonData, secretKey);
      safeStorage.setItem(storeKeyName, encryptedData);
    } catch (e) {
      console.error('Encryption failed', e);
      return false;
    }
    return true;
  }

  decryptJSONObjectSaved(storeKeyName: string, secretKey: string): any {
    const encryptedData = localStorage.getItem(storeKeyName);
    if (encryptedData) {
      try {
        return this.decryptJSONObject(encryptedData, secretKey);
      } catch (e) {
        console.error('Decryption failed', e);
      }
    }
    return {};
  }

  decryptJSONObject(encryptedData: string, secretKey: string): any {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (e) {
      console.error('Decryption failed', e);
      return {};
    }
  }
}
